var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { SelectorCore, } from '@core-front/selector';
import FormHelper from '@telia-front/form-helper';
import Grid, { GridColumn } from '@telia-front/grid';
const Selector = (props) => {
    const { theme } = props, rest = __rest(props, ["theme"]);
    return (React.createElement(SelectorCore, Object.assign({}, rest, { "data-theme": theme, components: {
            FormHelper,
            Grid: SelectorGrid,
            GridColumn,
        } })));
};
// define as separate component - if defined inline, it'll be defined as a new component for every render, which will break focus management.
const SelectorGrid = (gridProps) => React.createElement(Grid, Object.assign({}, gridProps));
export { Selector as default };
